import { StablecoinActivityFilter, StablecoinGroupBy, StablecoinReportDefinitionCreate } from '../../models/report.model';

export class InitStablecoinReportsState {
	static readonly type: string = '[StablecoinReports] InitStablecoinReportsState';
}

export class ClearStablecoinReportsState {
	static readonly type: string = '[StablecoinReports] ClearStablecoinReportsState';
}

export class ResetStablecoinReportsState {
	static readonly type: string = '[StablecoinReports] ResetStablecoinReportsState';
}

export class GetStablecoinReportDefinitions {
	static readonly type: string = '[StablecoinReports] GetStablecoinReportDefinitions';
}

export class CreateStablecoinReportDefinition {
	static readonly type: string = '[StablecoinReports] CreateStablecoinReportDefinition';
	constructor(public body: StablecoinReportDefinitionCreate) {}
}

export class UpdateStablecoinReportDefinition {
	static readonly type: string = '[StablecoinReports] UpdateStablecoinReportDefinition';
	constructor(
		public reportId: string,
		public body: StablecoinReportDefinitionCreate
	) {}
}

export class DeleteStablecoinReportDefinition {
	static readonly type: string = '[StablecoinReports] DeleteStablecoinReportDefinition';
	constructor(public reportId: string) {}
}

export class GetStablecoinActivity {
	static readonly type: string = '[StablecoinReports] GetStablecoinActivity';
	constructor(
		public filter: StablecoinActivityFilter,
		public cursor?: string
	) {}
}

export class GetStablecoinActivitySummary {
	static readonly type: string = '[StablecoinReports] GetStablecoinActivitySummary';
	constructor(
		public groupBy: StablecoinGroupBy,
		public filter: StablecoinActivityFilter
	) {}
}

export class ExportStablecoinActivity {
	static readonly type: string = '[StablecoinReports] ExportStablecoinActivity';
	constructor(public filter: StablecoinActivityFilter) {}
}
